import { useEffect, useState } from 'react';

import { Chip } from '@/components/ui/Chip';
import { isFixtureData, subscribeFixtureFlag } from '@/lib/api/client';

/**
 * dev fixture 警示（tools/fixture-api.mjs）。
 *
 * P1 是六個人平行開工的階段，前端一定會早於某幾個端點完成，所以 dev 有一個
 * fixture middleware 讓頁面在 `mkt.price_daily` 還是 0 列時就能被打開與截圖。
 *
 * 那就必須有這個 chip。**一張看起來像正式環境的假資料截圖，比沒有截圖更糟**——
 * 它會被貼進進度報告，然後沒有人記得那是假的。fixture 的每個回應都帶
 * `X-Stock-Fixture` 標頭，只要有任何一個回應帶了，這個 chip 就亮著。
 */
export function FixtureBadge() {
  const [on, setOn] = useState(isFixtureData);

  useEffect(() => subscribeFixtureFlag(setOn), []);

  if (!on) return null;
  return (
    <Chip tone="warn" title="這些數字來自 tools/fixture-api.mjs，不是資料庫。正式環境不會出現。">
      FIXTURE 資料
    </Chip>
  );
}
